module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ornament"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/orn_top.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "PN",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('span', {
    staticClass: "FinaHyphen"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('span', {
    staticClass: "FinaHyphen"
  }, [_vm._v("-")]), _vm._v(" PART ONE "), _c('span', {
    staticClass: "FinaHyphen"
  }, [_vm._v("-")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "PTb"
  }, [_vm._v("Wickam Farm,")]), _vm._v(" "), _c('p', {
    staticClass: "PT"
  }, [_vm._v("Oxfordshire")]), _vm._v(" "), _c('p', {
    staticClass: "ornament2"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/orn_bottom.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f84fa252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part1.vue
// module id = 69
// module chunks = 0